import Vue from "vue";
import Vuex from "vuex";
import md5 from "js-md5";

import { applyFilters } from "./utils/applyFilters";
import { getUnique } from "./utils/getUnique";
import {
  mapProperties,
  bendProtectionsToObjects,
} from "./utils/property-mapping";
import intersection from "lodash.intersection";

// Vue.config.devtools = true

Vue.use(Vuex);

export default new Vuex.Store({
  state() {
    return {
      // defaults
      svgDefaults: require("@/vuex-modules/svg-defaults"),
      colorMap: require("@/vuex-modules/color-map"),
      lightColors: require("@/vuex-modules/light-colors.js"),
      configuratorType2: 'sachsenkabel',
      isInCorruptedState: false,

      // loaded up front
      cables: [],
      plugs: [],
      cablesPlugsCombinations: [],
      bendProtections: [],
      plugsBendProtectionsCombinations: [],
      spreaders: [],
      whips: [],
      cablesWhipsCombinations: [],
      plugsWhipsCombinations: [],
      velcro: [
        { artikel_id: "YA99-9999", velcro: "Klettband zur Kabelfixierung" },
      ],
      serialNumber: [
        { artikel_id: "YA99-9998", serialNumber: "Seriennummer Sachsenkabel" },
      ],
      fixations: [],
      protections: [],
      labels: [],

      // application logic ;)
      filters: {
        cables: {
          // cableType: 'I-F(ZN)H',
          // cableColor: 'erikaviolett'
          // polarity: null // for MTP cables only
        },
        plugsA: {},
        plugsB: {},
        polarity: {},
        bendProtectionsA: {},
        bendProtectionsB: {},
        spreadersA: [],
        spreadersB: [],
        whipsA: {},
        whipsAStepping: {},
        whipsB: {},
        whipsBStepping: {},
        velcro: {
          artikel_id: "YA99-9999",
        },
        serialNumber: {
          artikel_id: "YA99-9998",
        },
        fixationsA: [],
        fixationsB: [],
        protectionsA: [],
        protectionsB: [],
        labels: [],
        labelsA: [],
        labelsB: [],
      },
      defaultFilters: {
        cables: {},
        plugsA: {},
        plugsB: {},
        polarity: {},
        bendProtectionsA: {},
        bendProtectionsB: {},
        spreadersA: [],
        spreadersB: [],
        whipsAStepping: {},
        whipsB: {},
        whipsBStepping: {},
        labels: {},
        labelsA: {},
        labelsB: {},
      },
      lastFilters: {
        cables: [],
        plugsA: [],
        plugsB: [],
        polarity: [],
        bendProtectionsA: [],
        bendProtectionsB: [],
        spreadersA: [],
        spreadersB: [],
        whipsA: [],
        whipsAStepping: [],
        whipsB: [],
        whipsBStepping: [],
        velcro: [],
        serialNumber: [],
        fixationsA: [],
        fixationsB: [],
        protectionsA: [],
        protectionsB: [],
        labels: [],
        labelsA: [],
        labelsB: [],
      },
      autoAppliedFilters: {
        cables: [],
        plugsA: [],
        plugsB: [],
        polarity: [],
        bendProtectionsA: [],
        bendProtectionsB: [],
        spreadersA: [],
        spreadersB: [],
        whipsA: [],
        whipsAStepping: [],
        whipsB: [],
        whipsBStepping: [],
        velcro: [],
        serialNumber: [],
        fixationsA: [],
        fixationsB: [],
        protectionsA: [],
        protectionsB: [],
        labels: [],
        labelsA: [],
        labelsB: [],
      },

      // produced by configurator
      partsList: {
        cables: [],
        plugsA: [],
        plugsB: [],
        bendProtectionsA: [],
        bendProtectionsB: [],
        spreadersA: [],
        spreadersB: [],
        whipsA: [],
        whipsAStepping: [],
        whipsB: [],
        whipsBStepping: [],
        options: [],
        fixationsA: [],
        fixationsB: [],
        protectionsA: [],
        protectionsB: [],
        labels: [],
        labelsA: [],
        labelsB: [],
      },

      customLabelSideA: {
        line1: "",
        line2: "",
      },
      customLabelSideB: {
        line1: "",
        line2: "",
      },

      cableCompositionDataUri: null,

      navigationDisabled: {
        patchCord: false,
        fanout: true,
        breakout: false,
        trunk: false,
        fbgs: true,
        cake: true
      },

      getsDataCenterProducts: false,

      cableLength: 1.0,
      price: 0,
      listPrice: 0,
      configuratorType: null,
      cablePricePerMeter: 0,
      baseCablePrice: 0,
      minPrice: 0,

      // configurator settings
      autoFill: true,
      autoFillVisible: true,
      switchedLayout: true,
      summaryVisible: true,
      loadedProduct: false,
      respecifyId: null,
      respecifyData: {},
      loggedIn: false, // if the user is logged in
      discount: 0,
      surcharge: 21,
      getsNewCatalog: false,
      isPigtail: null,
      sideBPick: null,
      hints: {
        "patch-cord": {
          pages: {
            cable: [
              // { type: 'information', messageId: 'hints.disappearing-colors' }
            ],
          },
          specs: {
            labels: {
              id: {
                "YA03-0004": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
                "YA03-0003": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
              },
            },
          },
        },
        trunk: {
          specs: {
            // specs hints must be named like the filters (store.js/state.filters)
            protectionsA: {
              id: {
                "XB01-0001": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0002": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0003": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0004": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0005": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0008": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
              },
            },
            protectionsB: {
              id: {
                "XB01-0001": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0002": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0003": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0004": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0005": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0008": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
              },
            },

            spreadersA: {
              id: {
                "XC01-0020": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0025": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0033": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0034": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0035": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0036": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0038": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M25"],
                },
                "XC01-0021": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M32"],
                },
                "XC01-0026": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M32"],
                },
                "XC01-0027": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M32"],
                },
                "XC01-0031": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M32"],
                },
                "XC01-0032": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M32"],
                },
                "XC01-0037": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["A", "M32"],
                },
              },
            },
            spreadersB: {
              id: {
                "XC01-0020": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0025": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0033": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0034": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0035": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0036": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0038": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M25"],
                },
                "XC01-0021": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M32"],
                },
                "XC01-0026": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M32"],
                },
                "XC01-0027": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M32"],
                },
                "XC01-0031": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M32"],
                },
                "XC01-0032": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M32"],
                },
                "XC01-0037": {
                  type: "information",
                  messageId: "hints.spreaders.no-protection-needed",
                  fillInData: ["B", "M32"],
                },
              },
            },
            labelsA: {
              id: {
                "YA03-0004": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
                "YA03-0003": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
              },
            },
            labelsB: {
              id: {
                "YA03-0004": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
                "YA03-0003": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
              },
            },
            // cables: {
            //   cableColor: {
            //     blau: {
            //       type: 'information',
            //       messageId: 'hints.nice-color'
            //     }
            //   }
            // }
          },
        },
        breakout: {
          pages: {
            options: [
              {
                type: "information",
                messageId: "hints.breakout-differing-whip-color",
              },
            ],
          },
          specs: {
            // specs hints must be named like the filters (store.js/state.filters)
            protectionsA: {
              id: {
                "XB01-0001": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0002": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0003": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0004": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0005": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
                "XB01-0008": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["A"],
                },
              },
            },
            protectionsB: {
              id: {
                "XB01-0001": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0002": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0003": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0004": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0005": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
                "XB01-0008": {
                  type: "information",
                  messageId: "hints.protections.backwards-stepped",
                  fillInData: ["B"],
                },
              },
            },
            labelsA: {
              id: {
                "YA03-0004": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
                "YA03-0003": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
              },
            },
            labelsB: {
              id: {
                "YA03-0004": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
                "YA03-0003": {
                  type: "information",
                  messageId: "hints.custom-label",
                },
              },
            },
          },
        },
        manual: [],
      },

      // navigation available
     enabledConfiguratorTypes: {
      patchcord: true,
      breakout: true,
      trunk: true,
      fanout: false,
      fbgs: false,
      cake: false // ✅ add this
    },



      // bug fixes
      customLabelBX: 0,

      // feature toggles
      features: {
        fetchProductNumberEnabled: [
          "emcom-go-dw2",
          "localhost",
          "sachsenkabel3.evalmate.ito-consult.de",
        ].includes(window.location.hostname),
        displayConfiguration: !["pulse.sachsenkabel.de"].includes(
          window.location.hostname
        ),
        displayPricePerMeter: !["pulse.sachsenkabel.de"].includes(
          window.location.hostname
        ),
      },

      // cache for the { id, spec } objects
      shopIdToSpecMap: [],

      userData: {
        id: null,
        username: null,
        customerNumber: null,
      },

      cartItemsCount: 0,
      projectAddProduct: false,
      projects: [],

      // survicate on mobile
      mobileSurvicateLoaded: false,

      // data to recalculate price
      pricingRequestData: {
        baseLength: null,
        surcharge: null,
        productGroup: null,
        cableLength: null,
        partsList: null,
      },
      showPrice: false,
    };
  },
  mutations: {
    setState(state, { stateKey, data }) {
      Vue.set(state, stateKey, data);
    },
    setFilter(state, { filterKey, propertyName, propertyValue }) {
      // changing plug filters needs to reset according bend protetions
      if (filterKey.startsWith("plugs")) {
        Vue.delete(
          state.filters[filterKey.replace("plugs", "bendProtections")],
          "id"
        );
      }

      Vue.set(state.filters[filterKey], propertyName, propertyValue);
    },
    removeFilter(state, { filterKey, propertyName }) {
      // changing plug filters needs to reset according bend protetions
      if (filterKey.startsWith("plugs")) {
        Vue.delete(
          state.filters[filterKey.replace("plugs", "bendProtections")],
          "id"
        );
      }

      Vue.delete(state.filters[filterKey], propertyName);
    },
    clearAllFilters(state) {
      Object.keys(state.filters).forEach((key) => {
        Vue.set(state.filters, key, {});
      });
    },
    clearFilters(state, { filterKey }) {
      if (state.loadedProduct) Vue.set(state, "loadedProduct", false);
      Vue.set(state.filters, filterKey, {});
    },
    setLastFilter(state, { filterKey, propertyName }) {
      Vue.set(state.lastFilters, filterKey, propertyName);
    },
    removeLastFilter(state, { filterKey }) {
      Vue.set(state.lastFilters, filterKey, null);
    },
    clearLastFilter(state, { filterKey }) {
      Vue.set(state.lastFilters, filterKey, null);
    },
    setAutoAppliedFilter(state, { filterKey /*, sourceKey */, propertyName }) {
      // eslint-disable-next-line
      // console.log(sourceKey, [...new Set([... state.autoAppliedFilters[filterKey], propertyName])])
      Vue.set(state.autoAppliedFilters, filterKey, [
        ...new Set([...state.autoAppliedFilters[filterKey], propertyName]),
      ]);
    },
    clearAutoAppliedFilters(state, { filterKey }) {
      Vue.set(state.autoAppliedFilters, filterKey, []);
    },
    addToPartsList(state, { partType, partNumber }) {
      Vue.set(state.partsList, partType, [
        ...state.partsList[partType],
        partNumber,
      ]);
    },
    clearPartsList(state, { partType }) {
      Vue.set(state.partsList, partType, []);
    },
    resetPartsList(state) {
      Vue.set(state, "partsList", {
        cables: [],
        plugsA: [],
        plugsB: [],
        bendProtectionsA: [],
        bendProtectionsB: [],
        spreadersA: [],
        spreadersB: [],
        whipsA: [],
        whipsAStepping: [],
        whipsB: [],
        whipsBStepping: [],
        options: [],
        fixationsA: [],
        fixationsB: [],
        protectionsA: [],
        protectionsB: [],
        labels: [],
        labelsA: [],
        labelsB: [],
      });
    },
    setAutoFill(state, { autoFill }) {
      Vue.set(state, "autoFill", autoFill);
    },
    cloneStateObject(state, { stateKey, sourceKey, destinationKey }) {
      Vue.set(state[stateKey], destinationKey, state[stateKey][sourceKey]);
    },
    // resetBendProtectionsAfterPlugFilterChange(state, { filterKey }) {
    //   if (filterKey.startsWith('plugs')) {
    //     Vue.delete(state.filters, filterKey.replace('plugs', 'bendProtections'))
    //   }
    // }
    setLoggedIn(state, value) {
      state.loggedIn = value;
      state.showPrice = value;
      state.respecifyId = value;
    },
    setConfiguratorType(state, type) {
      state.configuratorType2 = type;
    },
  },
  actions: {
    async fetchInitialData({ state, commit }, { stateKey, url }) {
      try {
        let response = await Vue.axios.get(url);
        return commit("setState", {
          stateKey,
          data: mapProperties(stateKey, response.data.data.data),
        });
      } catch (err) {
        Vue.rollbar.error("can not fetch data for ", {
          stateKey,
          from: url,
          err,
        });
        state.isInCorruptedState = true;
      }
    },
    setLastFilterAndFilter(
      { state, commit },
      { filterKey, propertyName, propertyValue }
    ) {
      if (state.autoFill) commit("setLastFilter", { filterKey, propertyName });

      commit("setFilter", { filterKey, propertyName, propertyValue });
    },
    clearLastFilterAndFilter({ state, commit }, { filterKey }) {
      if (filterKey === "") return;

      if (state.autoFill) commit("clearLastFilter", { filterKey });

      commit("clearFilters", { filterKey });
    },
    trySetAutoFillValues(
      { state, getters, commit },
      { scope, filterKey, propertyName }
    ) {
      if (
        state.autoFill &&
        !(propertyName in state.autoAppliedFilters[filterKey])
      ) {
        let sourceKey = state.lastFilters[filterKey];
        // eslint-disable-next-line
        // console.log(sourceKey)
        // resolve the value from either the getters or the state
        // console.log({scope, key: filterKey, propertyName })

        let disabled = getters.disabledPropertyValuesWithoutSelf({
          scope,
          key: filterKey,
          propertyName,
        });
        let value = getters
          .distinctPropertyValues({ scope, key: filterKey, propertyName })
          .filter((item) => !disabled.includes(item))[0];

        // eslint-disable-next-line
        // console.log(value)

        if (!(propertyName in state.filters[filterKey])) {
          commit("setAutoAppliedFilter", {
            filterKey,
            propertyName,
            sourceKey,
          });
          commit("setFilter", {
            filterKey,
            propertyName,
            propertyValue: value,
          });
        }
      }
    },
    tryRemoveAutoAppliedFilters({ state, commit }, { filterKey }) {
      if (state.autoFill) {
        state.autoAppliedFilters[filterKey].forEach((filter) => {
          commit("removeFilter", { filterKey, propertyName: filter });
        });

        commit("clearAutoAppliedFilters", { filterKey });
      }
    },
    removeAutoAppliedFiltersAndLastFilterAndFilter(
      { state, commit },
      { filterKey, propertyName }
    ) {
      if (state.autoFill && state.lastFilters.filterKey === propertyName) {
        // remove auto applied filters from filters
        state.autoAppliedFilters[filterKey].forEach((key) => {
          commit("removeFilter", { filterKey, propertyName: key });
        });
        // remove the unselected filter
        commit("removeFilter", { filterKey, propertyName });

        // reset state
        return commit("clearAutoAppliedFilters", filterKey);
      }

      // remove the unselected filter
      commit("removeFilter", { filterKey, propertyName });
      // reset state
      commit("clearLastFilter", filterKey);
    },
    cacheShopIdWithSpecification({ state, getters, commit }, shopId) {
      
      commit("setState", {
        stateKey: "shopIdToSpecMap",
        data: state.shopIdToSpecMap.concat([
          { key: shopId, value: getters.uniqueSpec },
        ]),
      });
    },
  },
  getters: {
    getCssColor: (state) => (colorName) =>
      state.colorMap[colorName] || state.colorMap.default,
    distinctPropertyValues:
      (state, getters) =>
      ({ scope, key, propertyName, sort = true }) => {
        switch (typeof sort) {
          case "function":
            return getUnique(
              scope === "getters" ? getters[key] : state[key],
              propertyName
            ).sort(sort);
          case "boolean": {
            if (sort)
              return getUnique(
                scope === "getters" ? getters[key] : state[key],
                propertyName
              ).sort();

            return getUnique(
              scope === "getters" ? getters[key] : state[key],
              propertyName
            );
          }
          default:
            return getUnique(
              scope === "getters" ? getters[key] : state[key],
              propertyName
            );
        }
      },
    disabledPropertyValuesWithoutSelf:
      (state, getters) =>
      ({ scope, key, propertyName }) => {
        // eslint-disable-next-line
        // console.log(scope, key, propertyName)

        // guard
        if (scope !== "state" && scope !== "getters") return; // throw 'scope for getter is not acceptable: ' + scope

        // calculate
        let internalScope = scope === "state" ? state[key] : getters[key];

        // not self for more flexibility
        // clone filters
        let filtersForKey = Object.assign({}, state.filters[key]);
        // try to remove self
        delete filtersForKey[propertyName];
        // filter with removed self
        let filtered = applyFilters(filtersForKey, internalScope);

        let uniqueAvailable = getUnique(internalScope, propertyName);
        let uniqueFiltered = getUnique(filtered, propertyName);
        let disabled = uniqueAvailable.filter(
          (ua) => !uniqueFiltered.includes(ua)
        );

        // eslint-disable-next-line
        // console.log(filtered, uniqueAvailable, uniqueFiltered, disabled)
        return disabled;
      },

    // prefilter the cables so that they are combinable
    cables: (state) =>
      state.cables.filter(
        (cable) =>
          state.cablesPlugsCombinations.filter(
            (comboItem) => comboItem.cableId === cable.id
          ).length > 0
      ),

    // fanout specific
    fanoutCables: (state) => state.cables, //.filter(cable => state.cablesPlugsCombinations.filter(comboItem => comboItem.cableId === cable.id).length > 0),

    remainingCables: (state, getters) =>
      applyFilters(state.filters.cables, getters.cables),
    selectedValue: (state) => (filterKey, propertyName) => {
      if (state.filters[filterKey][propertyName])
        return state.filters[filterKey][propertyName];
      return null;
    },
    filters: (state) => state.filters,
    lastFilter: (state) => (filterKey) => state.lastFilters[filterKey],
    plugsA: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesPlugsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredPlugs = state.plugs.filter((plug) =>
          possibleCombinations.map((combo) => combo.plugId).includes(plug.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredPlugs;
      }
      return [];
    },
    plugsB: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesPlugsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredPlugs = state.plugs.filter((plug) =>
          possibleCombinations.map((combo) => combo.plugId).includes(plug.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredPlugs;
      }
      return [];
    },
    remainingPlugsA: (state, getters) =>
      applyFilters(state.filters.plugsA, getters.plugsA),
    remainingPlugsB: (state, getters) =>
      applyFilters(state.filters.plugsB, getters.plugsB),

    mappedBendProtections: (state) =>
      bendProtectionsToObjects(state.bendProtections),
    selectedBendProtectionA: (state, getters) =>
      applyFilters(
        state.filters.bendProtectionsA,
        getters.mappedBendProtections
      ).length === 1
        ? applyFilters(
            state.filters.bendProtectionsA,
            getters.mappedBendProtections
          )[0]
        : null,
    selectedBendProtectionB: (state, getters) =>
      applyFilters(
        state.filters.bendProtectionsB,
        getters.mappedBendProtections
      ).length === 1
        ? applyFilters(
            state.filters.bendProtectionsB,
            getters.mappedBendProtections
          )[0]
        : null,
    remainingBendProtectionsA: (state, getters) => {
      if (getters.remainingPlugsA.length === 1) {
        let plugProductNumber = getters.remainingPlugsA[0].id;
        let possibleCombinations =
          state.plugsBendProtectionsCombinations.filter(
            (combo) => combo.plugId === plugProductNumber
          );
        let filteredBendProtections = getters.mappedBendProtections.filter(
          (bendProtection) =>
            possibleCombinations
              .map((combo) => combo.bendProtectionId)
              .includes(bendProtection.id)
        );

        // do not show two faced bend protections on simplex cables
        // can not be managed via matrices
        if (getters.selectedValue("cables", "fiberCount") == 1)
          filteredBendProtections = filteredBendProtections.filter(
            (bendProtection) =>
              bendProtection.colorTop === bendProtection.colorBottom
          );

        // flexible bend protections only work for cables with 2.5mm or lower diameter
        // can not be managed via matrices
        // trunk, breakout?
        if (getters.singleElementsDiameter > 2.5)
          filteredBendProtections = filteredBendProtections.filter(
            (bendProtection) => bendProtection.flexibility !== "flexibel"
          );

        return filteredBendProtections;
      }
      // Vue.delete(state.filters.bendProtectionsA, 'id')
      return [];
    },
    filteredBendProtectionsA: (state, getters) =>
      applyFilters(
        state.filters.bendProtectionsA,
        getters.remainingBendProtectionsA
      ),
    remainingBendProtectionsB: (state, getters) => {
      if (getters.remainingPlugsB.length === 1) {
        let plugProductNumber = getters.remainingPlugsB[0].id;
        let possibleCombinations =
          state.plugsBendProtectionsCombinations.filter(
            (combo) => combo.plugId === plugProductNumber
          );
        let filteredBendProtections = getters.mappedBendProtections.filter(
          (bendProtection) =>
            possibleCombinations
              .map((combo) => combo.bendProtectionId)
              .includes(bendProtection.id)
        );

        // do not show two faced bend protections on simplex cables
        // can not be managed via matrices
        if (getters.selectedValue("cables", "fiberCount") == 1)
          filteredBendProtections = filteredBendProtections.filter(
            (bendProtection) =>
              bendProtection.colorTop === bendProtection.colorBottom
          );

        // flexible bend protections only work for cables with 2.5mm or lower diameter
        // can not be managed via matrices
        // trunk, breakout?
        if (getters.singleElementsDiameter > 2.5)
          filteredBendProtections = filteredBendProtections.filter(
            (bendProtection) => bendProtection.flexibility !== "flexibel"
          );

        return filteredBendProtections;
      }
      // Vue.delete(state.filters.bendProtectionsB, 'id')
      return [];
    },
    filteredBendProtectionsB: (state, getters) =>
      applyFilters(
        state.filters.bendProtectionsB,
        getters.remainingBendProtectionsA
      ),
    linearizedPartsList: (state) =>
      Object.entries(state.partsList)
        .map(([, value]) => value)
        .flatten(),
    whipsA: (state, getters) => {
      if (
        getters.remainingCables.length === 1 &&
        getters.remainingPlugsA.length === 1
      ) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesWhipsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredWhips = state.whips.filter((whip) =>
          possibleCombinations.map((combo) => combo.whipId).includes(whip.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        let sortedWhips = filteredWhips.sort((a, b) => {
          if (a.length < b.length) return -1;
          if (a.length > b.length) return 1;
          return 0;
        });
        return sortedWhips;
      }
      return [];
    },
    remainingWhipsA: (state, getters) =>
      applyFilters(state.filters.whipsA, getters.whipsA),
    whipsB: (state, getters) => {
      if (
        getters.remainingCables.length === 1 &&
        getters.remainingPlugsB.length === 1
      ) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesWhipsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredWhips = state.whips.filter((whip) =>
          possibleCombinations.map((combo) => combo.whipId).includes(whip.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        let sortedWhips = filteredWhips.sort((a, b) => {
          if (a.length < b.length) return -1;
          if (a.length > b.length) return 1;
          return 0;
        });
        return sortedWhips;
      }
      return [];
    },
    remainingWhipsB: (state, getters) =>
      applyFilters(state.filters.whipsB, getters.whipsA),
    protectionsA: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesProtectionsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredProtections = state.protections.filter((protection) =>
          possibleCombinations
            .map((combo) => combo.protectionId)
            .includes(protection.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredProtections;
      }
    },
    protectionsB: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesProtectionsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredProtections = state.protections.filter((protection) =>
          possibleCombinations
            .map((combo) => combo.protectionId)
            .includes(protection.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredProtections;
      }
    },
    spreadersA: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesSpreadersCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredSpreaders = state.spreaders.filter((spreader) =>
          possibleCombinations
            .map((combo) => combo.spreaderId)
            .includes(spreader.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredSpreaders) //eslint-disable-line
        return filteredSpreaders;
      }
    },
    spreadersB: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesSpreadersCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredSpreaders = state.spreaders.filter((spreader) =>
          possibleCombinations
            .map((combo) => combo.spreaderId)
            .includes(spreader.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredSpreaders;
      }
    },
    fixationsA: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesFixationsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredProtections = state.fixations.filter((fixation) =>
          possibleCombinations
            .map((combo) => combo.fixationId)
            .includes(fixation.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredProtections;
      }
    },
    fixationsB: (state, getters) => {
      if (getters.remainingCables.length === 1) {
        let cableProductNumber = getters.remainingCables[0].id;
        let possibleCombinations = state.cablesFixationsCombinations.filter(
          (combo) => combo.cableId === cableProductNumber
        );
        let filteredProtections = state.fixations.filter((fixation) =>
          possibleCombinations
            .map((combo) => combo.fixationId)
            .includes(fixation.id)
        );
        // console.log(cableProductNumber, possibleCombinations, filteredPlugs)
        return filteredProtections;
      }
    },
    displayHints:
      (state) =>
      ({ configuratorType, page }) => {
        let pageHints = [];
        if (
          state.hints &&
          state.hints[configuratorType] &&
          state.hints[configuratorType].pages &&
          state.hints[configuratorType].pages[page]
        )
          pageHints = state.hints[configuratorType].pages[page];

        let specHints = [];
        if (
          state.hints &&
          state.hints[configuratorType] &&
          state.hints[configuratorType].specs
        ) {
          let possibleSpecHints = Object.entries(
            state.hints[configuratorType].specs
          );
          possibleSpecHints.forEach(([specKey]) => {
            Object.entries(state.filters[specKey])
              .filter(
                ([key, value]) =>
                  state.hints[configuratorType].specs[specKey][key] &&
                  state.hints[configuratorType].specs[specKey][key][value]
              )
              .forEach(([hintKey, selectedHintValue]) => {
                specHints.push(
                  state.hints[configuratorType].specs[specKey][hintKey][
                    selectedHintValue
                  ]
                );
              });
          });
        }
        return pageHints.concat(specHints).concat(state.hints.manual);
      },
    minCableLengthTrunk(state, getters) {
      let minLength = 3.0;
      let whipALengthFloat = 0.0;

      try {
        let whipALength = state.whips.filter(
          (item) => item.id === getters.selectedValue("whipsA", "id")
        )[0].length;
        whipALengthFloat = parseFloat(
          whipALength.replace("m", "").replace(",", ".")
        );
      } catch (error) {
        // eslint-disable-next-line
      }

      let whipBLengthFloat = 0;
      try {
        let whipBLength = state.whips.filter(
          (item) => item.id === getters.selectedValue("whipsB", "id")
        )[0].length;
        whipBLengthFloat = parseFloat(
          whipBLength.replace("m", "").replace(",", ".")
        );
      } catch (error) {
        // eslint-disable-next-line
      }

      return minLength + whipALengthFloat + whipBLengthFloat;
    },
    cableLengthTrunk(state, getters) {
      if (state.cableLength < getters.minCableLengthTrunk) {
        state.cableLength = getters.minCableLengthTrunk;
        return getters.minCableLengthTrunk;
      }

      return parseFloat(state.cableLength).toFixed(1);
    },
    whipAId: (state, getters) => getters.selectedValue("whipsA", "id"),
    whipBId: (state, getters) => getters.selectedValue("whipsB", "id"),
    singleElementsDiameter(_, getters) {
      if (getters.remainingCables.length === 1) {
        let diameter = parseFloat(
          getters.remainingCables[0].diameter
            .replace(/^(mm)(.*)$/, "")
            .replace(",", ".")
        );
        return isNaN(diameter)
          ? // trunk cables are getting the diameter of the whips which is always 2.0mm
            2.0
          : diameter;
      }
      return null;
    },
    uniqueSpec: (state) => {
      // get the things that identify a unique spec
      let {
        filters,
        partsList,
        customLabelA,
        customLabelB,
        isPigtail,
        cableLength,
      } = state;

      // produce something hashable and comparable
      let uniqueSpec = JSON.stringify({
        cableLength,
        filters,
        partsList,
        customLabelA,
        customLabelB,
        isPigtail,
      });

      return uniqueSpec;
    },
    // the addToCart function is working by first checking if a product with the same specification already exists in the shopIdToSpecMap.
    // if it does, it simply adds the quantity to the existing product
    // if it doesn't, it creates a new product in the backend and then adds the quantity to it
    // the currentShopId is then stored in the shopIdToSpecMap with the uniqueSpec as the key

    uniqueSpecHash: (_, getters) => md5(getters.uniqueSpec),
    currentShopId: (state, getters) => {
      let item = state.shopIdToSpecMap.find(
        (item) => item.value === getters.uniqueSpec
      );
      //eslint-disable-next-line
      console.log(
        "currentShopId getter, computed uniqueSpec:",getters.uniqueSpec);
      //eslint-disable-next-line
      console.log("shopIdToSpecMap contents:", state.shopIdToSpecMap);

      return item ? item.key : null;
    },

    orderedPartsList: (state) => {
      // order = cable, spreadersA, plugsA, bendProtectionsA, dustProtectionsA,
      //          whipsA, protectionsA, fixationsA, labelsA, spreadersB, plugsB,
      //          bendProtectionsB, dustProtectionsB, whipsB, protectionsB,
      //          fixationsB, labelsB, paidExtra
      return [
        ...state.partsList.cables,

        // side A according to internal spec
        ...state.partsList.spreadersA,
        ...state.partsList.plugsA,
        ...state.partsList.bendProtectionsA,
        // dustProtections are currently not part of the configurator
        ...state.partsList.whipsA,
        ...state.partsList.protectionsA,
        ...state.partsList.fixationsA,
        ...state.partsList.labelsA,

        // side B according to internal spec
        ...state.partsList.spreadersB,
        ...state.partsList.plugsB,
        ...state.partsList.bendProtectionsB,
        // dustProtections are currently not part of the configurator
        ...state.partsList.whipsB,
        ...state.partsList.protectionsB,
        ...state.partsList.fixationsB,
        ...state.partsList.labelsB,

        // paidExtra currently unsupported by configurator
      ];
    },
    trunkWhipsA: (state, getters) => {
      // guard to only return data when a certain cable and plug is selected
      if (
        !(
          getters.remainingCables.length === 1 &&
          getters.remainingPlugsA.length === 1
        )
      )
        return [];

      // get all remainign combinations
      let remainingCableWhipCombos = state.cablesWhipsCombinations.filter(
        (combo) => combo.cableId === getters.remainingCables[0].id
      );
      let remainingPlugWhipCombos = state.plugsWhipsCombinations.filter(
        (combo) => combo.plugId === getters.remainingPlugsA[0].id
      );

      // intersect the combinations to get the dependend upon whip Ids
      let whipIds = intersection(
        remainingCableWhipCombos.map((combo) => combo.whipId),
        remainingPlugWhipCombos.map((combo) => combo.whipId)
      );

      // return remaining whips
      return state.whips.filter((whip) => whipIds.includes(whip.id));
    },
    trunkWhipsB: (state, getters) => {
      // guard to only return data when a certain cable and plug is selected
      if (
        !(
          getters.remainingCables.length === 1 &&
          getters.remainingPlugsB.length === 1
        )
      )
        return [];

      // get all remainign combinations
      let remainingCableWhipCombos = state.cablesWhipsCombinations.filter(
        (combo) => combo.cableId === getters.remainingCables[0].id
      );
      let remainingPlugWhipCombos = state.plugsWhipsCombinations.filter(
        (combo) => combo.plugId === getters.remainingPlugsB[0].id
      );

      // intersect the combinations to get the dependend upon whip Ids
      let whipIds = intersection(
        remainingCableWhipCombos.map((combo) => combo.whipId),
        remainingPlugWhipCombos.map((combo) => combo.whipId)
      );

      // return remaining whips
      return state.whips.filter((whip) => whipIds.includes(whip.id));
    },
  },
});

// test master
